export default "__VITE_ASSET__DSxdMXYN__"